import {forwardRef} from 'react';
import {Duration, Fade} from '../../transition';
import {DetailedProps, join} from '../../utils';

import styles from './overlay.module.less';

export type OverlayProps = {
	hide?: boolean;
	hideDuration?: Duration,
	disableAnimation?: boolean;
} & DetailedProps<HTMLDivElement>;

export const Overlay = forwardRef<HTMLDivElement, OverlayProps>((props, ref) => {
	const {hide, disableAnimation, children, className, hideDuration, ...divProps} = props;

	const overlay = <div ref={ref} className={join(styles.overlay, className)} {...divProps}>
		{children}
	</div>;

	if (!disableAnimation) {
		return <Fade in={!hide} duration={hideDuration || 'common'} animateOnMount>
			{overlay}
		</Fade>;
	}

	return overlay;
});

Overlay.displayName = 'Overlay';
